module.exports = __webpack_public_path__ + "static/media/background-all.f06a6ead.svg";